/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import {
  Chart,
  BarSeries,
  ArgumentAxis,
  Tooltip,
} from '@devexpress/dx-react-chart-material-ui';
import { Animation, EventTracker } from '@devexpress/dx-react-chart';
import { format } from 'date-fns';

import { apiUrl } from '../../utilities/apiUrl';
import {
  computeTotalHours,
  formatData,
  getDates,
  getOverallTotal,
} from '../../utilities/totalHoursData';
import { sortByCheckInDate } from '../../utilities/sortBy';

import '../../css/bargraph.css';

const style = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  py: 3,
  px: 5,
};

const totalStyle = {
  height: '3rem',
  width: '100%',
  bgcolor: '#84d8c5',
  borderRadius: '5px',
};

const totalHrsStyle = {
  position: 'absolute',
  zIndex: '1',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: '1.4rem',
  fontWeight: '600',
};

const subs = {
  fontWeight: '500',
  fontSize: '12px',
  textTransform: 'uppercase',
  textAlign: 'center',
  color: '#828282',
};

export const CutOff = (props) => {
  const [empId] = useOutletContext();
  const [timesheetCutoff, setTimesheetCutoff] = useState([]);
  const today = format(new Date(), 'dd MMM yyyy');
  const timesheetData = formatData(timesheetCutoff);
  const combinedData = computeTotalHours(timesheetData);
  const dates = getDates(timesheetCutoff);
  const total = getOverallTotal(timesheetCutoff);
  const progress = total;
  const cleanData = combinedData;

  useEffect(() => {
    fetch(apiUrl('/timesheet?cutoff=true&empid=' + empId), {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        let sortedTimesheetData = sortByCheckInDate(data.data);
        setTimesheetCutoff(sortedTimesheetData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [empId, props.isActive]);

  return (
    <Box sx={style}>
      <Typography
        sx={{
          textAlign: 'center',
          fontWeight: '700',
          fontSize: '1.8rem',
          mb: '1.2rem',
        }}
        variant="h4"
        component="div"
        gutterBottom
      >
        CUTOFF SUMMARY
      </Typography>
      {cleanData.length !== 0 ? (
        <Chart height={170} data={cleanData.reverse()}>
          <ArgumentAxis indentFromAxis={5} showTicks={false} />
          <BarSeries
            color="#3A4152"
            barWidth={1.1}
            valueField="hours"
            argumentField="date"
          />
          <EventTracker />
          <Tooltip />
          <Animation />
        </Chart>
      ) : (
        <Typography
          align="center"
          variant="subtitle1"
          sx={{ height: 170, pt: 6 }}
        >
          No Data
        </Typography>
      )}
      <Box
        sx={{
          width: '95%',
          alignSelf: 'center',
          my: '1rem',
          position: 'relative',
        }}
      >
        <Typography sx={totalHrsStyle}>
          {Math.floor(progress * 1000) / 1000} HOURS
        </Typography>
        <Box sx={totalStyle} />
      </Box>
      <Typography sx={subs}>
        {(() => {
          if (dates.length === 0) {
            return String('No time record for this cutoff');
          } else if (dates.length === 1) {
            return String('Daily time record for ' + dates[0]);
          } else {
            return String(
              'Daily time record from ' +
                dates[dates.length - 1] +
                ' to ' +
                dates[0]
            );
          }
        })()}
      </Typography>
    </Box>
  );
};
